<app-status-badge
  [colourScheme]="statusBadgeColourSchemeEnum"
  name="sim-publication-status"
>
  {{ simPublicationStatus }}
</app-status-badge>
